


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { WorkDescriptionForm } from '@/models/config'

// Components
import { FormCreateEditWorkDescription } from '@/components/config'

@Component({
    name: 'ModalCreateEditWorkDescription',
    components: {
        FormCreateEditWorkDescription
    }
})
export default class ModalCreateEditWorkDescription extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) workDescription!: WorkDescriptionForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva Descriptión de Trabajo'
        }
        return 'Editar Descriptión de Trabajo'
    }
}
